import { motion } from "framer-motion";
import { MapPin, ExternalLink } from "lucide-react";
import { BlurIn, ScaleReveal } from "./ScrollAnimations";

const GMB_LINK = "https://maps.app.goo.gl/ZBNHFw3Qe1MadnTM6";

export const MapSection = () => {
  return (
    <section id="location" data-testid="map-section" className="py-24 sm:py-32 bg-white relative">
      <div className="container mx-auto px-6 sm:px-8 max-w-7xl">
        <BlurIn className="text-center mb-14">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C8A23A] mb-4 block" style={{ fontFamily: "'Outfit', sans-serif" }}>Visit Our Store</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A] mb-4" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="map-heading">
            Find Us on <span className="text-[#7A1A31]">Avenue Road</span>
          </h2>
          <p className="text-base text-[#6B7280] max-w-lg mx-auto" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>
            29, Avenue Rd, Sri Krishna Building, Cubbonpete, Bengaluru 560002
          </p>
        </BlurIn>

        <ScaleReveal>
          <div className="relative rounded-xl overflow-hidden border border-black/5 shadow-xl shadow-black/5">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124415.89771793841!2d77.44098801640627!3d12.972056000000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16098eb1714f%3A0xc06f7ed19606d01d!2sEagle%20Diaries-%20Emcee%20Sons!5e0!3m2!1sen!2sin!4v1775913193508!5m2!1sen!2sin"
              title="Eagle Diaries - Emcee Sons Location"
              data-testid="google-map-embed"
              className="w-full border-0"
              style={{ height: "450px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </ScaleReveal>

        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-8 text-center"
        >
          <motion.a
            href={GMB_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="map-directions-link"
            className="inline-flex items-center gap-2 text-sm text-[#7A1A31] hover:text-[#5C162E] font-medium transition-colors"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            <MapPin className="w-4 h-4" /> Get Directions <ExternalLink className="w-3.5 h-3.5" />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};
